import React from "react";
import { useLang } from "@/lib/LanguageContext";

export default function Terms() {
  const { t } = useLang();
  return (
    <div className="min-h-screen max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="terms-page">
      <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white mb-8">
        {t("termsTitle")}
      </h1>
      <div className="prose-dark space-y-6 text-stone-400 text-sm leading-relaxed">
        <p><strong className="text-white">Date d'effet :</strong> 13 avril 2026</p>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">1. Acceptation des conditions</h2>
          <p>En utilisant What To Cook, vous acceptez ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser l'application.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">2. Description du service</h2>
          <p>What To Cook est une application de g&#233;n&#233;ration de recettes par intelligence artificielle. Le service vous permet de :</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>G&#233;n&#233;rer des recettes &#224; partir d'ingr&#233;dients s&#233;lectionn&#233;s ou du nom de plats connus</li>
            <li>Visualiser des photos de recettes g&#233;n&#233;r&#233;es par IA</li>
            <li>Sauvegarder vos recettes favorites</li>
            <li>Consulter votre historique de recettes</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">3. Comptes utilisateurs</h2>
          <p>Vous &#234;tes responsable de la s&#233;curit&#233; de votre compte et de votre mot de passe. Vous devez nous informer imm&#233;diatement de toute utilisation non autoris&#233;e de votre compte.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">4. Abonnement Premium</h2>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>L'abonnement Premium donne acc&#232;s &#224; des recettes illimit&#233;es</li>
            <li>Les paiements sont trait&#233;s via Stripe de mani&#232;re s&#233;curis&#233;e</li>
            <li>Vous pouvez annuler votre abonnement &#224; tout moment</li>
            <li>Aucun remboursement n'est accord&#233; pour la p&#233;riode en cours</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">5. Contenu g&#233;n&#233;r&#233; par IA</h2>
          <p>Les recettes et images sont g&#233;n&#233;r&#233;es par intelligence artificielle. Bien que nous nous efforcions de fournir des informations pr&#233;cises :</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Les recettes sont &#224; titre indicatif uniquement</li>
            <li>V&#233;rifiez toujours les allerg&#232;nes et les restrictions alimentaires</li>
            <li>What To Cook n'est pas responsable des r&#233;sultats culinaires</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">6. Propri&#233;t&#233; intellectuelle</h2>
          <p>Le contenu, les fonctionnalit&#233;s et le design de What To Cook sont prot&#233;g&#233;s par les droits d'auteur. Les recettes g&#233;n&#233;r&#233;es peuvent &#234;tre utilis&#233;es librement pour un usage personnel.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">7. Limitation de responsabilit&#233;</h2>
          <p>What To Cook est fourni "tel quel". Nous ne garantissons pas que le service sera ininterrompu ou exempt d'erreurs.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">8. Contact</h2>
          <p>Pour toute question, contactez-nous &#224; : <span className="text-amber-500">support@k2what-to-cook.com</span></p>
        </section>
      </div>
    </div>
  );
}
